module.exports = {"id":"193172","name":"Ben Marshall","rating":"71","photo":"./data/images/photos/0/193172.png","club":{"name":"Millwall","logo":"./data/images/clubs/Millwall.png"},"positions":["MD","MG","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BenMarshall0.json
// module id = 554
// module chunks = 0